
//const BASE_URL = 'https://9488a812-47e5-4b67-a6ac-9dd3623971f2.mock.pstmn.io';
//const BASE_URL = 'http://127.0.0.1:8000/api';
//const APP_NAME = 'Spree motors';

//export const BASE_URL = 'http://127.0.0.1:8000/api';;
export const APP_NAME = 'Spree Motors';;
export const APP_CAMEL_NAME = 'Spree motors';;
export const APP_ON_NAME = 'Spree motor';;


export const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";

//export default BASE_URL;
